import { logoutuser } from "../services";
import { getLocalStorage } from "./localstorage";

export const clearSession = async (source: string, redirectTo?: string,noNeedToLogout?:boolean) => {
  console.log("clearSession called from:", source);
  const userDetails: any = getLocalStorage("userDetails");
  if(!noNeedToLogout && userDetails){
  const { accessToken} = JSON.parse(userDetails)
  if(accessToken){
    await logoutuser()
  }
}
  localStorage.clear();
  localStorage.removeItem("userDetails");
  if (redirectTo) {
    window.location.href = redirectTo;
  } else {
    window.open("https://www.bbc.com", "_blank", "noopener,noreferrer");
    window.open("https://www.google.com", "_blank", "noopener,noreferrer");
    window.open("https://www.bing.com", "_blank", "noopener,noreferrer");
    history.replaceState({}, "", "/auth/login");
    goBlank();
  }
};

export const goBlank = () => {
  history.replaceState({}, "", "/auth/login");
  window.history.pushState(null, "", window.location.href);
  window.location.replace("about:blank");
};
